import './style/index.css';
import App from './components/App';

export default App;

/*
  Components will load like this:
  App -> FileChooser -> Loader -> Main
*/
